import { IntlProvider } from 'react-intl';
import { core } from '@tock/coretypes';
import _ from 'lodash';

import { Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';
import BookingHistoryItem from 'components/account/BookingHistoryItem';

interface Props {
  emptyStateText?: string;
  history: core.PastPurchase[];
  userLocale: string;
  // Whether to display booking actions. Valid only on bookings in the future.
  showBookingActions: boolean;
}

export default class BookingHistory extends BaseComponent<Props> {
  render() {
    const { emptyStateText, history, userLocale, showBookingActions } = this.props;

    if (_.isNull(history)) {
      return (
        <div className="BookingHistory-emptyState">
          <Typography color="inherit" component="span" variant="body02">
            You need to confirm your email address before you can view your reservations.
          </Typography>
        </div>
      );
    }

    if (history.length === 0) {
      return (
        <div className="BookingHistory-emptyState">
          <Typography color="inherit" component="span" variant="body02">
            {emptyStateText}
          </Typography>
        </div>
      );
    }

    return (
      <IntlProvider locale={userLocale}>
        <div className="BookingHistory">
          {_.map(history, (transaction) => (
            <BookingHistoryItem
              item={transaction}
              key={transaction.id}
              showBookingActions={showBookingActions}
            />
          ))}
        </div>
      </IntlProvider>
    );
  }
}
